import classNames from "classnames";
import React from "react";
import { Flex } from "../../Common/Flex";
import "./ImageBalloons.css";
import Label from "../../Common/Label";

type ImageBalloonsProps = {
    images: { id: string; url: string | null | undefined }[];
    showMax: number;
};

function ImageBalloons(props: ImageBalloonsProps) {
    const { images, showMax } = props;

    const topImages = images.slice(0, showMax);
    const nMore = images.length - showMax;

    return (
        <Flex.Row>
            {topImages.map(({ id, url }, index) =>
                url ? (
                    <img
                        key={id}
                        src={url}
                        alt=""
                        className={classNames("image-balloon", {
                            "image-balloon-overflow": index > 0,
                        })}
                    />
                ) : (
                    <div
                        className={classNames("image-balloon", {
                            "image-balloon-overflow": index > 0,
                        })}
                        key={id}
                    />
                ),
            )}
            {nMore > 0 && (
                <div className="image-balloon__n-indicator">
                    <Label.Small.SemiBold.P50>+{nMore}</Label.Small.SemiBold.P50>
                </div>
            )}
        </Flex.Row>
    );
}

export default ImageBalloons;
